<script>
import TextInput from "@/components/TextInput";

export default {
  components: {
    TextInput,
  },
  data() {
    return {
      beneficiaryName: "",
      beneficiaryAddress: "",
      beneficiaryCity: "",
      zipOfOrganization: "",
      bankName: "",
      swiftRoutingNumber: "",
      ibanNumber: "",
      isChecked: false,
    };
  },
  methods: {
    validate() {
      this.$emit("checked", !this.isChecked);
    },
  },
};
</script>

<template>
  <div>
    <p class="mb-4 text-sm text-lightGrey">
      {{ $t("views.modals.signup.info_banking") }}
    </p>
    <hr />
    <br />
    <div class="w-full flex flex-row space-around mb-4">
      <TextInput
        id="beneficiaryName"
        v-model="beneficiaryName"
        data-cy="beneficiaryName"
        :label="$t('views.modals.signup.beneficiaryName')"
        :placeholder="$t('views.modals.signup.placeholders.beneficiaryName')"
        type="text"
        class="pr-1"
      />
      <TextInput
        id="beneficiaryAddress"
        v-model="beneficiaryAddress"
        data-cy="beneficiaryAddress"
        :label="$t('views.modals.signup.beneficiaryAddress')"
        :placeholder="$t('views.modals.signup.placeholders.beneficiaryAddress')"
        type="text"
        class="pl-1"
      />
    </div>
    <div class="w-full flex flex-row space-around mb-4">
      <TextInput
        id="beneficiaryCity"
        v-model="beneficiaryCity"
        data-cy="beneficiaryCity"
        :label="$t('views.modals.signup.beneficiaryCity')"
        :placeholder="$t('views.modals.signup.placeholders.beneficiaryCity')"
        type="text"
        class="pr-1"
      />
      <TextInput
        id="zipOfOrganization"
        v-model="zipOfOrganization"
        data-cy="zipOfOrganization"
        :label="$t('views.modals.signup.zipOfOrganization')"
        :placeholder="$t('views.modals.signup.placeholders.zipOfOrganization')"
        type="text"
        class="pl-1 pr-1"
      />
      <TextInput
        id="bankName"
        v-model="bankName"
        data-cy="bankName"
        :label="$t('views.modals.signup.bankName')"
        :placeholder="$t('views.modals.signup.placeholders.bankName')"
        type="text"
        class="pl-1"
      />
    </div>
    <div class="w-full flex flex-row space-around mb-4">
      <TextInput
        id="ibanNumber"
        v-model="ibanNumber"
        data-cy="ibanNumber"
        :label="$t('views.modals.signup.ibanNumber')"
        :placeholder="$t('views.modals.signup.placeholders.ibanNumber')"
        type="text"
        :maxlenght="27"
        :minlenght="27"
        class="pr-1"
      />
      <TextInput
        id="swiftRoutingNumber"
        v-model="swiftRoutingNumber"
        data-cy="swiftRoutingNumber"
        :label="$t('views.modals.signup.swiftRoutingNumber')"
        :placeholder="$t('views.modals.signup.placeholders.swiftRoutingNumber')"
        type="text"
        class="pl-1"
      />
    </div>
    <div class="w-full flex flex-row space-around mb-4">
      <TextInput
        id="mail"
        v-model="istat"
        data-cy="istat"
        :label="$t('views.modals.signup.istat')"
        :placeholder="$t('views.modals.signup.placeholders.istat')"
        type="text"
        class="pr-1"
      />
    </div>
    <div class="my-4 flex">
      <div class="flex flex-col items-center justify-center mx-8">
        <input
          id="confidentiality"
          v-model="isChecked"
          type="checkbox"
          data-cy="NDACheckbox"
          @input="validate"
        />
      </div>
      <label
        class="z-10 leading-6 text-sm flex-grow"
        v-html="$t('views.modals.signup.readNDA')"
      />
    </div>
  </div>
</template>

<style></style>
